globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Settings = appCustomerSpace.Controllers.Settings || {};

appCustomerSpace.Controllers.Settings.SocialDesignController = (function (superClass) {
  utils.extend(SocialDesignController, superClass);

  function SocialDesignController() {
    this.$form = $('form.social_design_setting_form');
    this.$previewContainer = $('.preview-container');
    this.$iframePreview = this.$previewContainer.find('iframe');

    return SocialDesignController.__super__.constructor.apply(this, arguments);
  }

  $.extend(SocialDesignController.prototype, {
    init: function () {
      var controller = this;

      appCustomerSpace.Loader().start({ $container: controller.$previewContainer, options: { text: false } });
      controller._initEvents();

      return SocialDesignController.__super__.init.apply(this, arguments);
    },
    _initEvents: function () {
      var controller = this;

      controller.initialIframeSrc = controller.$iframePreview.attr('src');
      controller._previewTimeout = null;

      controller.$form.find('.save-design-on-change').on('change', function () {
        clearTimeout(controller._previewTimeout);
        controller._previewTimeout = setTimeout(function () {
          controller._preview();
        }, 250);
      });

      controller.$form.on('submit', function (e) {
        e.preventDefault();
        controller._save();
      });

      controller.$form.on('click', '.js-cancel-design', function (e) {
        e.preventDefault();
        window.location.reload();
      });

      controller.$form.on('change', 'select#business_services_social_settings_design_setting_border_radius_size', function () {
        if ($(this).val() == 'disabled') {
          controller.$form.find('.form-group.border_radius_place').hide();
        } else {
          controller.$form.find('.form-group.border_radius_place').show();
        }
      });

      controller.$iframePreview.on('load', function () {
        appCustomerSpace.Loader().stop({ $container: controller.$previewContainer })
      });

      window.addEventListener('message', function (event) {
        if (event.data.type === 'setHeight') {
          controller.$iframePreview.css('height', event.data.height + 'px');
        }
      });
    },
    _preview: function () {
      var controller = this;

      appCustomerSpace.Loader().start({ $container: controller.$previewContainer, options: { text: false } });

      var url = new URL(controller.initialIframeSrc, window.location.origin);
      var fd = new FormData(controller.$form[0]);

      var templateKey = controller.$form.find('#preview_template_key').val();
      if (templateKey) {
        url.searchParams.set('template_key', templateKey);
      }

      fd.forEach(function (value, key) {
        if (value instanceof File) return;

        if (value === null || value === undefined) return;
        if (typeof value === 'string' && value.length === 0) return;

        url.searchParams.set(key, value);
      });

      controller.$iframePreview[0].src = url.toString();
    },
    _save: function () {
      var controller = this;

      $('.recent-changes-info').show();

      appCustomerSpace.Loader().start({ $container: controller.$previewContainer, options: { text: false } });

      $.ajax({
        url: controller.$form.attr('action'),
        method: 'PATCH',
        data: new FormData(controller.$form[0]),
        contentType: false,
        processData: false,
        success: function (data) {
          if (data.response) {
            controller.$iframePreview[0].src = data.iframe_preview_src;
            controller.initialIframeSrc = data.iframe_preview_src;
          }
        },
        error: function (data) {

        }
      })
    }
  });

  return SocialDesignController;

})(appCustomerSpace.Controllers.Settings.MainController);
